import { bannerStyle } from "./styles"
import { IconButton } from "../../buttons"

export interface BannerProps {
	message: string | React.ReactNode
	onClose: () => void
}

export const Banner: React.FC<BannerProps> = ({ message, onClose }) => {
	return (
		<div css={bannerStyle}>
			{message}
			<IconButton icon="xmark" family="solid" onClick={onClose} color="white" />
		</div>
	)
}
